import { createFileRoute } from '@tanstack/react-router';

import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { ServersStep } from '@/features/onboarding/components/steps/riot/serversStep';
import { getMyUserOptions } from '@/features/users/hooks/useGetMyUser/getMyUser.options';

export const Route = createFileRoute('/_protected/onboarding/_steps/servers')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const userResponse =
      await context.queryClient.ensureQueryData(getMyUserOptions());

    if (userResponse.user.riotPuuid) {
      await context.queryClient.ensureQueryData(
        getValorantPlayerOptions({ puuid: userResponse.user.riotPuuid }),
      );
    }
  },
});

function RouteComponent() {
  return <ServersStep />;
}
